import {GET_PUBLISHED_JOBS , GET_PUBLISHED_JOBS_SUCCESSFULL,  GET_PUBLISHED_JOBS_FAILED,  GET_RECRUITMENT_DATA,
    GET_RECRUITMENT_DATA_SUCCESSFULL,  GET_RECRUITMENT_DATA_FAILED , GET_DASHBOARD_CARDS_DATA,
    GET_DASHBOARD_CARDS_DATA_SUCCESS, GET_DASHBOARD_CARDS_DATA_FAILED, GET_NEW_CANDIDATES_DATA, GET_NEW_CANDIDATES_DATA_SUCCESS,
    GET_NEW_CANDIDATES_DATA_FAILED, GET_RECRUITMENT_REPORT, GET_RECRUITMENT_REPORT_SUCCESS, GET_RECRUITMENT_REPORT_FAILED,
    GET_JOB_STATUS_DATA,GET_JOB_STATUS_DATA_SUCCESS,GET_JOB_STATUS_DATA_FAILED,
    GET_UPCOMING_INTERVIEWS_DATA, GET_UPCOMING_INTERVIEWS_DATA_SUCCESS, GET_UPCOMING_INTERVIEWS_DATA_FAIL ,
GET_JOB_COMPLETION_STATUS,  GET_JOB_COMPLETION_STATUS_SUCCESS , GET_JOB_COMPLETION_STATUS_FAIL,
GET_UPCOMING_INTERVIEWS_FILTER_DATA,GET_JOB_STATUS_FILTER_DATA,
// GET_UPCOMING_INTERVIEWS_FILTER_DATA_SUCCESS,
// GET_UPCOMING_INTERVIEWS_FILTER_DATA_FAIL ,
GET_UPDATE_INTERVIEW,
GET_UPDATE_INTERVIEW_SUCCESS,
GET_UPDATE_INTERVIEW_FAIL,
GET_UPCOMING_INTERVIEW_SUGGESTIONS, GET_UPCOMING_INTERVIEW_SUGGESTIONS_SUCCESS, GET_UPCOMING_INTERVIEW_SUGGESTIONS_FAIL,
GET_JOBSTATUS_SUGGESTIONS, GET_JOBSTATUS_SUGGESTIONS_SUCCESS,GET_JOBSTATUS_SUGGESTIONS_FAIL, GET_CLIENT_JOBS, GET_CLIENT_JOBS_SUCCESS, GET_CLIENT_JOBS_FAIL, GET_CANDIDATE_HIRE_FAIL, GET_CANDIDATE_HIRE_SUCCESS, GET_CANDIDATE_HIRE,
GET_INTERVIEW_PROCESS_MODAL_DATA,GET_INTERVIEW_PROCESS_MODAL_DATA_SUCCESS,GET_INTERVIEW_PROCESS_MODAL_DATA_FAIL,GET_DASHBOARD_TOTALINTERVIEW_DATA,
GET_DASHBOARD_TOTALINTERVIEW_DATA_SUCCESS,GET_DASHBOARD_TOTALINTERVIEW_DATA_FAILED
} from './actionTypes'

const initialState = {
    loader: false,
    customJSON: null,
    tempData: null,
    buttonLoader: false,
    publishedJobs: null,
    dashboardCardsData: null,
    recruitmentData: null,
    recruitmentReport:null,
    newCandidatesData: null,
    successMessage: null,
    errorMessage: null,
    jobStatusData: null,
    upComingInterview: null,
    jobStatusDataLoader: false,
    upComingInterviewLoader :false,
    jobComplitionStatus: null,
    jobComplitionError: null,
    updateInterviewMessage: null,
    updateInterviewErrorMessage: null,
    suggestionData: null,
    suggestionFailMsg: null,
    jobStatusSuggestionsData: null,
    jobStatusSuggestionsError: null,
    clientJobsLoader : false,
    clientJobsData: null,
    clientJobsError: null,
    candidateHiredLoader : false,
    candidateHiredData: null,
    candidateHiredError: null,
    hireViewModal: null,
    hireViewModalError: null,
    temporaryData: null,
    todayInterviewCount: null,
    
}
const getPublishedJobsReducer = (state = initialState, action) => {

    switch (action.type) {

        case GET_JOBSTATUS_SUGGESTIONS:
            state = {
                ...state,
                jobStatusSuggestionsData: null,
                jobStatusSuggestionsError: null
            }
            break
            case GET_JOBSTATUS_SUGGESTIONS_SUCCESS:
                state = {
                    ...state,
                    jobStatusSuggestionsData: action.payload,
                    jobStatusSuggestionsError:null
                   

                }
                break
                case GET_JOBSTATUS_SUGGESTIONS_FAIL:
                    state = {
                        ...state,
                        jobStatusSuggestionsData: null,
                        jobStatusSuggestionsError: action.payload
                       
                    }
                    break



        case GET_UPCOMING_INTERVIEW_SUGGESTIONS:
            state = {
                ...state,
                suggestionData: null,
                suggestionFailMsg:null,
               
            }
            break
              case GET_UPCOMING_INTERVIEW_SUGGESTIONS_SUCCESS:
            state = {
                ...state,
                suggestionData: action.payload,
                suggestionFailMsg: null,
               
            }
            break
            case  GET_UPCOMING_INTERVIEW_SUGGESTIONS_FAIL:
                state = {
                    ...state,
                    suggestionData: null,
                    suggestionFailMsg: action.payload
                  
                }
                break

        case GET_UPDATE_INTERVIEW:
            state = {
                ...state,
                buttonLoader: true,
                updateInterviewMessage: null,
                updateInterviewErrorMessage: null
               
            }
            break

            case GET_UPDATE_INTERVIEW_SUCCESS:
                state = {
                    ...state,
                    buttonLoader: false,
                    updateInterviewMessage: action.payload,
                    updateInterviewErrorMessage: null
                   
                }
                break
                 case GET_UPDATE_INTERVIEW_FAIL:
            state = {
                ...state,
                buttonLoader:false,
                updateInterviewMessage: null,
                updateInterviewErrorMessage: action.payload               
            }
            break



        case GET_PUBLISHED_JOBS:
            state = {
                ...state,
                buttonLoader: true,
                customJSON: action.payload,
                publishedJobs: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case  GET_PUBLISHED_JOBS_SUCCESSFULL:
            state = {
                ...state,
                buttonLoader: false,
                publishedJobs: action.payload,
                recruitmentData: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case  GET_PUBLISHED_JOBS_FAILED:
            state = {
                ...state,
                buttonLoader: false,
                publishedJobs: null,
                successMessage: null,
                errorMessage: action.payload
            }
            break

            case GET_RECRUITMENT_DATA:
            state = {
                ...state,
                buttonLoader: true,
                // tempData: action.payload,
                recruitmentData: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case GET_RECRUITMENT_DATA_SUCCESSFULL:
            state = {
                ...state,
                buttonLoader: false,
                recruitmentData: action.payload,
                successMessage: null,
                errorMessage: null
            }
            break
        case GET_RECRUITMENT_DATA_FAILED:
            state = {
                ...state,
                recruitmentData: null,
                buttonLoader: false,
                publishedJobs: null,
                successMessage: null,
                errorMessage: action.payload
            }
            break

            case GET_DASHBOARD_CARDS_DATA:
            state = {
                ...state,
                buttonLoader: true,
                tempData: action.payload,
                dashboardCardsData: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case GET_DASHBOARD_CARDS_DATA_SUCCESS:
            state = {
                ...state,
                buttonLoader: false,
                dashboardCardsData: action.payload,
                successMessage: null,
                errorMessage: null
            }
            break
        case GET_DASHBOARD_CARDS_DATA_FAILED:
            state = {
                ...state,
                dashboardCardsData: null,
                buttonLoader: false,
                publishedJobs: null,
                successMessage: null,
                errorMessage: action.payload
            }
            break
            case  GET_NEW_CANDIDATES_DATA:
            state = {
                ...state,
                buttonLoader: true,
                tempData: action.payload,
                newCandidatesData: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case  GET_NEW_CANDIDATES_DATA_SUCCESS:
            state = {
                ...state,
                buttonLoader: false,
                newCandidatesData: action.payload,
                successMessage: null,
                errorMessage: null
            }
            break
        case   GET_NEW_CANDIDATES_DATA_FAILED:
            state = {
                ...state,
                newCandidatesData: null,
                buttonLoader: false,
                successMessage: null,
                errorMessage: action.payload
            }
            break

            case GET_RECRUITMENT_REPORT:
            state = {
                ...state,
                buttonLoader: true,
                tempData: action.payload,
                recruitmentReport: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case  GET_RECRUITMENT_REPORT_SUCCESS:
            state = {
                ...state,
                buttonLoader: false,
                recruitmentReport: action.payload,
                successMessage: null,
                errorMessage: null
            }
            break
        case GET_RECRUITMENT_REPORT_FAILED:
            state = {
                ...state,
                recruitmentReport: null,
                buttonLoader: false,
                successMessage: null,
                errorMessage: action.payload
            }
            break
            case GET_JOB_STATUS_FILTER_DATA:
                state = {
                    ...state,
                    jobStatusDataLoader: true,
                    // customJSON: action.payload,
                    jobStatusData:null,
                    publishedJobs: null,
                    successMessage: null,
                    errorMessage: null
                }
                break



            case  GET_JOB_STATUS_DATA:
            state = {
                ...state,
                jobStatusDataLoader: true,
                // customJSON: action.payload,
                jobStatusData:null,
                publishedJobs: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case GET_JOB_STATUS_DATA_SUCCESS:
            state = {
                ...state,
                jobStatusDataLoader: false,
                jobStatusData: action.payload,
                recruitmentData: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case  GET_JOB_STATUS_DATA_FAILED:
            state = {
                ...state,
                jobStatusDataLoader: false,
                publishedJobs: null,
                successMessage: null,
                errorMessage: action.payload
            }
            break

            case GET_UPCOMING_INTERVIEWS_DATA:
            state = {
                ...state,
                upComingInterviewLoader: true,
                // customJSON: action.payload,
                // jobStatusData:null,
                upComingInterview: null,
                publishedJobs: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case  GET_UPCOMING_INTERVIEWS_DATA_SUCCESS:
            state = {
                ...state,
                upComingInterviewLoader: false,
                upComingInterview: action.payload,
                recruitmentData: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case  GET_UPCOMING_INTERVIEWS_DATA_FAIL:
            state = {
                ...state,
                upComingInterviewLoader: false,
                publishedJobs: null,
                successMessage: null,
                errorMessage: action.payload
            }
            break

            case GET_UPCOMING_INTERVIEWS_FILTER_DATA:
                state = {
                    ...state,
                    upComingInterviewLoader: true,
                    // customJSON: action.payload,
                    // jobStatusData:null,
                    upComingInterview: null,
                    publishedJobs: null,
                    successMessage: null,
                    errorMessage: null
                }
                break

            //get job completion status
            case GET_JOB_COMPLETION_STATUS:
            state = {
                ...state,
                jobComplitionStatus: null,
                jobComplitionError: null
            }
            break
        case GET_JOB_COMPLETION_STATUS_SUCCESS:   
        state = {
                ...state,
                jobComplitionStatus: action.payload,
                jobComplitionError: null
            }
            break
        case GET_JOB_COMPLETION_STATUS_FAIL:
            state = {
                ...state,
                jobComplitionStatus:null,
                jobComplitionError: action.payload

            }
            break


            //recruitment agency bar chart 
            case GET_CLIENT_JOBS:
            state = {
                ...state,
                clientJobsLoader : true,
                clientJobsData: null,
                clientJobsError: null
            }
            break
        case GET_CLIENT_JOBS_SUCCESS:   
        state = {
                ...state,
                clientJobsLoader : false,
                clientJobsData: action.payload,
                clientJobsError: null
            }
            break
        case GET_CLIENT_JOBS_FAIL:
            state = {
                ...state,
                clientJobsLoader : false,
                clientJobsData:null,
                clientJobsError: action.payload

            }
            break
            case GET_CANDIDATE_HIRE:
                state = {
                    ...state,
                    candidateHiredLoader : true,
                    candidateHiredData: null,
                    candidateHiredError: null
                }
                break
            case GET_CANDIDATE_HIRE_SUCCESS:   
            state = {
                    ...state,
                    candidateHiredLoader : false,
                    candidateHiredData: action.payload,
                    candidateHiredError: null
                }
                break
            case GET_CANDIDATE_HIRE_FAIL:
                state = {
                    ...state,
                    candidateHiredLoader : false,
                    candidateHiredData:null,
                    candidateHiredError: action.payload
    
                }
                break

                case GET_INTERVIEW_PROCESS_MODAL_DATA:
                    state = {
                        ...state,
                        hireViewModal: null,
                        hireViewModalError: null
                    }
                    break
                    case GET_INTERVIEW_PROCESS_MODAL_DATA_SUCCESS:
                            state = {
                                ...state,
                                hireViewModal: action.payload,
                                hireViewModalError: null
                            }
                            break
                    case GET_INTERVIEW_PROCESS_MODAL_DATA_FAIL:
                                state = {
                                  ...state,
                                hireViewModal: null,
                                hireViewModalError:action.payload
                            }
                            break
                    case GET_DASHBOARD_TOTALINTERVIEW_DATA:
                            state = {
                                ...state,
                                buttonLoader: true,
                                temporaryData: action.payload,
                                todayInterviewCount: null,
                                successMessage: null,
                                errorMessage: null
                            } 
                            break
                    case GET_DASHBOARD_TOTALINTERVIEW_DATA_SUCCESS:
                            state = {
                                ...state,
                                buttonLoader: false,
                                todayInterviewCount: action.payload,
                                successMessage: null,
                                errorMessage: null

                            }
                            break
                    case GET_DASHBOARD_TOTALINTERVIEW_DATA_FAILED:
                            state = {
                                ...state,
                                todayInterviewCount: null,
                                buttonLoader: false,
                                successMessage: null,
                                errorMessage: action.payload
                            }
                            break


        default:
            state = { ...state }
            break
    }
    return state
}
export default  getPublishedJobsReducer